// extracted by mini-css-extract-plugin
export var banner = "_op-0";
export var settingRow = "_op-2";
export var titleIcon = "_op-1";